import { gql } from 'graphql-request';
import { STEP_EXECUTION_FIELDS } from './processExecution.queries';

// ============================================
// QUERIES
// ============================================

export const getMyWatchedProcesses = gql`
  query GetMyWatchedProcesses($pagination: PaginationInput) {
    getMyWatchedProcesses(pagination: $pagination) {
      items {
        processWatchlistId
        processId
        process {
          processId
          name
          summary
          status
        }
        createdAt
      }
      pageInfo {
        totalCount
        count
        offset
        limit
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

export const isProcessWatched = gql`
  query IsProcessWatched($processId: String!) {
    isProcessWatched(processId: $processId)
  }
`;

export const getMyWatchedPendingExecutions = gql`
  query GetMyWatchedPendingExecutions($pagination: PaginationInput) {
    getMyWatchedPendingExecutions(pagination: $pagination) {
      items {
        processExecutionId
        processId
        status
        startedAt
        completedAt
        processSnapshot
        process {
          processId
          name
        }
        startedByUser {
          userId
          displayName
        }
        assignedByUser {
          userId
          displayName
        }
        stepExecutions {
          ...StepExecutionFields
        }
        createdAt
      }
      pageInfo {
        totalCount
        count
        hasNextPage
        hasPreviousPage
      }
    }
  }
  ${STEP_EXECUTION_FIELDS}
`;

export const getMyWatchedPendingExecutionsCount = gql`
  query GetMyWatchedPendingExecutionsCount {
    getMyWatchedPendingExecutionsCount
  }
`;

export const getMyWatchedExecutions = gql`
  query GetMyWatchedExecutions(
    $pagination: PaginationInput
    $statusFilter: [ProcessExecutionStatus!]
    $dateRange: DateRangeInput
  ) {
    getMyWatchedExecutions(
      pagination: $pagination
      statusFilter: $statusFilter
      dateRange: $dateRange
    ) {
      items {
        processExecutionId
        processId
        status
        startedAt
        completedAt
        processSnapshot
        process {
          processId
          name
        }
        startedByUser {
          userId
          firstName
          lastName
          displayName
        }
        assignedByUser {
          userId
          firstName
          lastName
          displayName
        }
        stepExecutions {
          ...StepExecutionFields
        }
        createdAt
      }
      pageInfo {
        totalCount
        count
        offset
        limit
        hasNextPage
        hasPreviousPage
      }
    }
  }
  ${STEP_EXECUTION_FIELDS}
`;

// ============================================
// MUTATIONS
// ============================================

export const watchProcess = gql`
  mutation WatchProcess($input: WatchProcessInput!) {
    watchProcess(input: $input) {
      processWatchlistId
      processId
      createdAt
    }
  }
`;

export const unwatchProcess = gql`
  mutation UnwatchProcess($processId: String!) {
    unwatchProcess(processId: $processId) {
      affected
    }
  }
`;

const WatchlistGraphQL = {
  queries: {
    getMyWatchedProcesses,
    isProcessWatched,
    getMyWatchedPendingExecutions,
    getMyWatchedPendingExecutionsCount,
    getMyWatchedExecutions,
  },
  mutations: {
    watchProcess,
    unwatchProcess,
  },
};

export default WatchlistGraphQL;
